export default __webpack_public_path__ + "static/media/icons8-under-construction.60f94638.svg";